import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { userStore } from './store';

const firebaseConfig = {
  apiKey: "AIzaSyAP3n8UrnPsebVQF_srGvduHEwmB5ATafc",
  authDomain: "klad-364708.firebaseapp.com",
  projectId: "klad-364708",
  storageBucket: "klad-364708.appspot.com",
  messagingSenderId: "214087865873",
  appId: "1:214087865873:web:b1ebae918dd0bffa2f43b0"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  if (user) {
				firebase.firestore().collection('Users').doc(user.email).get().then((userProfileDoc) => {
					if (userProfileDoc.exists) {
            let userProfile = userProfileDoc.data();
            // console.log(userProfile.email);
						userStore.set({ 
              loggedIn: true, 
							email: userProfile.email,
							username: userProfile.username,
							organization: userProfile.organization });
          }
				}).catch((error) => console.log(error))
    // localStorage.setItem("authUser", JSON.stringify(user))
  } else {
    userStore.set({ loggedIn: false });
  }
})

export const auth = firebase.auth();
export const db = firebase.firestore();
// export const updateUserProfile = (user, data) => updateProfile(user, data);
export const provider = new firebase.auth.GoogleAuthProvider();